import request from '@/utils/request'

/**
 * 查询文件服务地址
 * @param {telephone} 手机号码
 */
export function GetFileSeriviceUrl(data) {
  return request({
    url: 'Common/GetFileSeriviceUrl',
    method: 'post',
    data
  });
}

export function getCloudImage(data) {
  return request({
    url: 'ElectronicFilmService/GetCloudImage',
    method: 'post',
    data
  });
}
/**
 * 通过手机验号码 获取验证码
 * @param {telephone} 手机号码
 */
export function SendVerificationCode(data) {
  return request({
    url: 'ElectronicFilmService/SendVerificationCode',
    method: 'post',
    data
  });
}
/**
 * 通过手机号码登录
 * @param {telephone} 手机号码
 * @param {verificationcode} 验证码
 */
export function Login(data) {
  return request({
    url: 'ElectronicFilmService/Login',
    method: 'post',
    data
  });
}

/**
 * 通过手机号码查询报告数据
 * @param {telephone} 手机号码
 */
export function GetPatientCloudReportInfos(data) {
  return request({
    url: 'ElectronicFilmService/GetPatientCloudReportInfos',
    method: 'post',
    data
  });
}

/**
 * 通过手机号码查询报告数据
 * @param {CloudImagePatientID} 患者ID
 * @param {IDs} 影像表ID
 */
export function AddCloudImageViewRecord(data) {
  return request({
    url: 'ElectronicFilmService/AddCloudImageViewRecord',
    method: 'post',
    data
  });
}

/**
 * 获取患者云报告
 * @param {patientReportID} 报告ID
 *  @param {securityCode} 安全吗
 */
export function GetSimplePatientReportInfo(data) {
  return request({
    url: 'ElectronicFilmService/GetSimplePatientReportInfo',
    method: 'post',
    data
  });
}

/**
 * 获取患者云报告图像
 * @param {patientReportID} 报告ID
 */
export function GetPatientReportImageInfos(data) {
  return request({
    url: 'ElectronicFilmService/GetPatientReportImageInfos',
    method: 'post',
    data
  });
}

/**
 * 根据患者云影像报告id获取支付授权信息
 * @param {hospitalID} 医院编号
 * @param {cloudImageReportID} 报告ID
 */
export function GetCloudImagePaymentPermissionInfo(data) {
  return request({
    url: 'ElectronicFilmService/GetCloudImagePaymentPermissionInfo',
    method: 'post',
    data
  });
}

/**
 * 添加支付信息
 * @param {info} 支付信息
 */
export function AddCloudImagePaymentOrderInfo(data) {
  return request({
    url: 'ElectronicFilmService/AddCloudImagePaymentOrderInfo',
    method: 'post',
    data
  });
}
export function UpdateCloudImagePaymentOrderPaymentStatus(data) {
  return request({
    url: 'ElectronicFilmService/UpdateCloudImagePaymentOrderPaymentStatus',
    method: 'post',
    data
  });
}
export function WXH5Pay(data) {
  return request({
    url: 'ElectronicFilmService/WXH5Pay',
    method: 'post',
    data
  });
}

/**
 * 根据支付类型获取支付参数信息
 * @param {Code} 微信授权
 * @param {info} 订单信息
 */
export function GetPayParameterByType(data) {
  return request({
    url: 'ElectronicFilmService/GetPayParameterByType',
    method: 'post',
    data
  });
}

export function GetCloudImageConfigInfoByReportID(data) {
  return request({
    url: 'ElectronicFilmService/GetCloudImageConfigInfoByReportID',
    method: 'post',
    data
  });
}
export function GetCloudImageReportInfoByID(data) {
  return request({
    url: 'ElectronicFilmService/GetCloudImageReportInfoByID',
    method: 'post',
    data
  });
}

export function GetWxH5PayResult(data) {
  return request({
    url: 'ElectronicFilmService/GetWxH5PayResult',
    method: 'post',
    data
  });
}


export function GetWPACSPrePath(data) {
  return request({
    url: 'ElectronicFilmService/GetWPACSPrePath',
    method: 'post',
    data
  });
}

export function GetCloudImageReportInfoByThirdVistParm(data) {
  return request({
    url: 'ElectronicFilmService/GetCloudImageReportInfoByThirdVistParm',
    method: 'post',
    data
  });
}